module.exports = __webpack_public_path__ + "img/logo01.eabe6b2f.png";